import { Building2 } from 'lucide-react';
import { cn } from '@/lib/cn';
import { OrgCard } from '@/features/OrgLayout/primitives/OrgCard';
import { EmptyState } from '@/components/EmptyState';
import { Skeleton } from '@/components/ui/skeleton';
import { useOrgStudentCompanyFit } from '@/lib/hooks/useOrg';
import { BAND_META } from '@/features/CompanyReadiness/bandMeta';

export function StudentCompanyFit({ userId }: { userId: string }) {
  const { data, isLoading, isError } = useOrgStudentCompanyFit(userId);
  const companies = data ?? [];

  return (
    <OrgCard className="p-6">
      <h3 className="text-lg font-semibold text-[#111827]">Company Fit</h3>
      {isLoading ? (
        <Skeleton className="mt-4 h-20 rounded-2xl" />
      ) : isError ? (
        <p className="mt-4 text-sm text-[#9ca3af]">Couldn&apos;t load company fit.</p>
      ) : companies.length === 0 ? (
        <EmptyState
          icon={Building2}
          title="Not enough data yet"
          description="Solve more problems to see company fit."
        />
      ) : (
        <div className="mt-4 flex flex-wrap gap-2">
          {companies.map((c) => (
            <span
              key={c.company}
              className={cn(
                'inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium',
                BAND_META[c.band].badgeClass,
              )}
            >
              <span className={cn('h-1.5 w-1.5 rounded-full', BAND_META[c.band].dotClass)} />
              {c.company}
              <span className="text-xs opacity-70">{Math.round(c.pct)}%</span>
            </span>
          ))}
        </div>
      )}
    </OrgCard>
  );
}
